import React from "react";
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { useFirebase, useFirestoreConnect, isLoaded } from 'react-redux-firebase'
import Moment from 'react-moment';

import Page from './Page';
import Loading from '../components/Loading';
import LinkButton from '../components/LinkButton';

const Users = () => {
  const users = useSelector(state => state.firestore?.ordered?.users)
  const firebase = useFirebase();

  const activate = async (userId) => {
    const sendActivationLink = firebase.functions().httpsCallable('sendActivationLink');
    try {
      await sendActivationLink({userId})
    } catch (e) {}
  }

  useFirestoreConnect({
    collection: 'users',
    orderBy: ["name", "desc"]
  })

  if (!isLoaded(users)) {
    return (
      <Page>
        <Loading />
      </Page>
    )
  }
  
  return (
    <Page action={<LinkButton to="/users/create">Create customer</LinkButton>}>
      <div className="table-responsive">
        <table className="table table-bordered table-lg">
          <thead>
            <tr>
              <th className="border-bottom-0">Name</th>
              <th className="border-bottom-0">Company name</th>
              <th className="border-bottom-0">Email</th>   
              <th className="border-bottom-0">In progress</th>
              <th className="border-bottom-0">Done</th>
              <th className="border-bottom-0">Published</th>
              <th className="border-bottom-0">Actions</th>
            </tr>
          </thead>
          <tbody>
            { users.map(user => (
              <tr key={user.id}>
                <td>
                  {user.name}
                </td>
                <td>
                  {user.companyName}
                </td>
                <td>
                  {user.email}
                </td>
                <td>{user.inProgressCount || 0}</td>
                <td>{user.doneCount || 0}</td>
                <td>{user.publishedCount || 0}</td>
                <td>
                  <ul class="list-unstyled list-inline mb-0">
                    <li class="list-inline-item"> 
                     <Link to={`/podcasts/by-user/${user.id}`} title="View customer podcasts">
                      <i className="fas fa-user"></i>
                     </Link>
                    </li> 
                    <li class="list-inline-item"> 
                     <Link to={`/podcasts/by-user/${user.id}/create`} title="Create podcast for customer">
                      <i className="fas fa-plus-square"></i>
                     </Link>
                    </li>
                    <li class="list-inline-item"> 
                     <Link to={`/users/${user.id}/edit`} title="Edit customers account">
                      <i className="fas fa-pen-square"></i>
                      </Link>
                    </li>
                    <li class="list-inline-item"> 
                     <i onClick={() => activate(user.id)} className="fas fa-user-plus" title="Send acccount activation"></i>
                    </li>
                  </ul>
                  <small class="text-muted">
                   { user?.lastActivationSent?.toDate()?.toString() && (
                    <Moment fromNow interval={1}>
                     {user?.lastActivationSent?.toDate()?.toString()}
                    </Moment>
                   )}
                  </small>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Page>
  )
}

export default Users;
